import { attr } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const Recommendation = ApplicationRecord.extend({
  attrs: {
    available_from: attr({ type: Date }),
    available_until: attr({ type: Date }),
    recipe_id: attr({ type: Number }),
    price: attr({ type: Number }),
    portions: attr({ type: Number }),
    priority: attr({ type: Number }),
    recipe_slot: attr({ type: Number }),
    sort_order: attr({ type: Number }),
    recommended: attr({ type: Boolean }),
  },
  static: {
    endpoint: '/recommendations',
    jsonapiType: 'recipes-recommendations',
  },
});

export default Recommendation;
